"use client";

import React from "react";
import { Wind, Sun, Leaf } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Morning Rituals",
  description: "Start your day with our artisanal coffee, ceremonial grade matcha, and fresh pastries that warm the soul.",
  icon: Wind
}, {
  title: "Midday Bites",
  description: "Savor our signature focaccia deli sandwiches and seasonal breakfast creations, crafted with premium local ingredients.",
  icon: Sun
}, {
  title: "European Market",
  description: "Explore a curated selection of imported European specialties, from fine chocolates to authentic pantry staples.",
  icon: Leaf
}];
export default function MorningRitualsMiddayBites() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="265055" id="morning-rituals-midday-bites" className="bg-background text-foreground py-16 md:py-20">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 text-center max-w-2xl mx-auto">
          <h2 className="font-default text-4xl md:text-5xl font-medium text-foreground mb-4 tracking-tight">
            Morning Rituals & Midday Bites
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            A warm, modern neighborhood destination in Enfield, CT, where artisanal coffee meets authentic European flavors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="group h-full bg-transparent border-none shadow-sm hover:shadow-md transition-all duration-400 hover:-translate-y-1 flex flex-col text-center">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-accent/50 text-secondary group-hover:text-primary group-hover:bg-accent transition-colors duration-300 mx-auto">
                      <Icon className="h-6 w-6" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-2xl font-medium text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-default">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}